import { render, staticRenderFns } from "./ChangelogModal.vue?vue&type=template&id=683f9606&"
import script from "./ChangelogModal.vue?vue&type=script&lang=js&"
export * from "./ChangelogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports